import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {LayoutConfigService, SplashScreenService} from '../../../../core/_base/layout';

@Component({
    selector: 'kt-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
    // Public proprties
    loaderLogo: string | undefined;
    loaderType: string | undefined;
    loaderMessage: string | undefined;

    @ViewChild('splashScreen', {static: true}) splashScreen: ElementRef;

    /**
     * Component constructor
     *
     * @param el: ElementRef
     * @param layoutConfigService: LayoutConfigService
     * @param splashScreenService: SplachScreenService
     */
    constructor(
        private el: ElementRef,
        private layoutConfigService: LayoutConfigService,
        private splashScreenService: SplashScreenService) {
    }

    /**
     * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
     */

    /**
     * On init
     */
    ngOnInit() {
        // init splash screen, see loader option in layout.config.ts
        const layoutConfig = this.layoutConfigService.getConfig();
        const loaderConfig = layoutConfig.loader;
        this.loaderLogo = loaderConfig.logo;
        this.loaderType = loaderConfig.type;
        this.loaderMessage = loaderConfig.message;

        this.splashScreenService.init(this.splashScreen);
    }
}
